import configDefault from "./config-default";

const config = {
  ...configDefault,
  code: "onefitnessclub.fr",
  appClassName: "OFC",
  analytics: {
    gtm: "GTM-PQ4C382",
  },
  favicon: "/ofc-favicon.png",
  title: "Je m'abonne | One Fitness Club",
  companyName: "One Fitness Club",
  website: "https://onefitnessclub.fr",
  notifyChannel: "one-fitness-club",
  turnstile: {
    siteKey: "0x4AAAAAAFRH8QoLs7KrNUN1",
  },
  htmlCustomCSS: "ofc.scss",
  header: {
    title: "Je m'abonne",
    logo: "/ofc-logo--colored-white.svg",
  },
  footer: {
    logo: "/ofc-logo--white.svg",
  },
  navigation: {
    ...configDefault.navigation,
    display: "line",
  },
  promoCode: {
    label: "Code promo ?",
    placeholder: "VOTRE CODE ICI",
    confirmLabel: "Appliquer",
    verifyingLabel: "vérifions...",
  },
  choice: {
    ...configDefault.choice,
    nameColor: "#E63F49",
    checkboxSelected: "#E63F49",
  },
  options: {
    title: "Choisissez vos options",
    message: "",
    nextLabel: "Suivant",
  },
  regulars: {
    title: "Boutique",
    nextLabel: "Suivant",
    useImg: "compact",
    imageBaseURL: "https://api.resamania.com",
    message: "Équipez-vous pour vos entraînements",
  },
  recap: {
    ...configDefault.recap,
    title: "",
    myOffer: "Mon offre",
    myOption: "Mes options",
    myCounter: "Mes équipements",
    payByCardLabel: "Total à payer",
  },
  plans: {
    ...configDefault.plans,
    displayCompanyAndClubName: true,
    beforeUser: true,
    formatName: (name) => {
      if (!name) return name;

      const SANS_ENGAGEMENT = "SANS ENGAGEMENT";
      const sansEngagementIndex = name
        .toLowerCase()
        .indexOf(SANS_ENGAGEMENT.toLowerCase());
      const hasSansEngagement = sansEngagementIndex !== -1;

      // On retire "Sans engagement" pour traiter le reste normalement
      const baseName = hasSansEngagement
        ? name.slice(0, sansEngagementIndex).trim()
        : name;

      // Permet d'avoir "SANS ENGAGEMENT" (et tout ce qui suit, ex: un astérisque) à la ligne suivante
      const sansEngagementSuffix = hasSansEngagement
        ? name.slice(sansEngagementIndex)
        : null;

      if (baseName.length > 20) return name;

      const words = baseName.split(" ");
      if (words.length < 2) return name;

      const penultimateWord = (words[words.length - 2] || "").toLowerCase();
      const linkWords = [
        "de",
        "du",
        "des",
        "d'",
        "la",
        "le",
        "les",
        "a",
        "au",
        "aux",
      ];
      const lastWord = words[words.length - 1];

      // When the word before the last one is a link word ("de", "du", ...),
      // keep both together and only highlight the final word.
      if (linkWords.includes(penultimateWord) && words.length >= 3) {
        const firstPart = words.slice(0, -2).join(" ");
        return (
          <div className="flex flex-col">
            <div className="highlight-group">
              {firstPart}
              {firstPart ? "\u00A0" : ""}
              <span className="highlight-group">
                {words[words.length - 2]}{" "}
                <span className="highlight">{lastWord}</span>
              </span>
            </div>
            {sansEngagementSuffix && <span>{sansEngagementSuffix}</span>}
          </div>
        );
      }

      words.pop();
      const rest = words.join(" ");
      return (
        <div className="flex flex-col">
          <div className="highlight-group">
            {rest}&nbsp;
            <span className="highlight">{lastWord}</span>
          </div>
          {sansEngagementSuffix && <span>{sansEngagementSuffix}</span>}
        </div>
      );
    },
    buttonTitle: "Je choisis cette offre",
    title: "Choisissez votre formule",
    topOfferTitle: "Top Vente",
    incitation: "Sélectionnez une formule",
    customConfig: {
      isIncluded: (club) => !club?.inPreOpening,
      subClass: "customSub", // ofc veut les sub2 et sub3 sans font bold, pour les isIncluded (= clubs pas en préouverture)
    },
    order: (plans, isMobile) => {
      console.log("Plans before sorting:", plans);
      return plans.sort((a, b) => {
        const orderA =
          parseInt(a.vel_datas.order || a.vel_datas.position || 0) +
          (isMobile && a.topOffer ? -100 : 0);
        const orderB =
          parseInt(b.vel_datas.order || b.vel_datas.position || 0) +
          (isMobile && b.topOffer ? -100 : 0);
        return orderA - orderB;
      });
    },
  },
  steps: {
    ...configDefault.steps,
    useSinglePageForm: true,
    clubSelect: {
      ...configDefault.steps.clubSelect,
      title: "Choisissez votre club",
      showMap: "Masquer la carte",
      hideMap: "Voir la carte",
      nextLabel: "Suivant",
      noAddress: false,
    },
    userForm: {
      ...configDefault.steps.userForm,
      internalOptins: {
        step: "summary",
        groups: [
          {
            id: "medicalDeclaration",
            label: "Déclaration médicale",
            required: true,
            type: "xor",
            options: [
              {
                key: "confirmMedicalAptitude",
                label:
                  "J’atteste n’avoir aucune contre-indication médicale à la pratique sportive en club de fitness",
              },
              {
                key: "agreesToConsultClubIfMedicalIssue",
                label:
                  "Dans le cas contraire, je m’engage à me rapprocher de ma salle de sport de référence.",
              },
            ],
          },
        ],
      },
    },
  },
  clubTransfer: {
    ...configDefault.clubTransfer,
    enabled: true,
  },
  stepsShortLabels: {
    ...configDefault.stepsShortLabels,
    contract: "Récapitulatif",
  },
  confirmation: {
    ...configDefault.confirmation,
    text: "FÉLICITATIONS ! Votre adhésion a bien été prise en compte, un e-mail de confirmation vous sera envoyé.",
    backLabel: "Retourner sur le site",
  },
  htmlStyle: `
		html {
			font-weight: 300;
			font-family: 'Kanit', sans-serif;
  		scrollbar-color: #E73943 #FDE0E0;
		}
	`,
  theme: {
    fontFamily: "Montserrat, sans-serif",
    buttonPrimary: {
      color: "#e63f49",
      text: "#fff",
    },
    buttonOther: {
      color: "black",
      text: "#fff",
    },
    loader: {
      border: "black",
      border2: "#252525",
    },
    buttonSecondary: {
      color: "black",
      text: "#fff",
    },
    stepHeader: {
      fontWeight: 600,
      fontSize: "1.25rem",
      paddingTop: "1rem",
    },
  },
};

export default config;
